import { SelectOption } from '@la/ds-ui-components';

export const getSelectOptions = (
  options: Record<string, string>
): SelectOption[] =>
  Object.entries(options).map(([key, value]) => ({ label: value, value: key }));
